import { useState } from "react";
import { performanceScreensConstants } from "../../../../constants";
import { updateStarRatingSelectedOptions } from "../../../utility";

const { GUEST_SENTIMENTS } = performanceScreensConstants;

export const useRatingCheckboxGroup = (
  selectedOption,
  setSelectedOption
) => {
  const [selectedRatingOption, setSelectedRatingOption] =
    useState(GUEST_SENTIMENTS);

  const handleRatingOptionChange = (event) => {
    setSelectedRatingOption(event.target.value);

    if (selectedOption.length > 0) {
      const updatedSelectedOption = updateStarRatingSelectedOptions(
        selectedOption,
        event.target.value
      );

      setSelectedOption(updatedSelectedOption);
    }
  };

  return {
    handleRatingOptionChange,
    selectedRatingOption,
  };
};
